import ClockIcon from '@/assets/svg/ui-elements/clock-filled-blue.svg';
import XCloseIcon from '@/assets/svg/ui-elements/close-circle-red.svg';
import EyeClosedIcon from '@/assets/svg/ui-elements/eye-closed.svg';
import OfficeIcon from '@/assets/svg/ui-elements/office-blue.svg';
import { colors } from '@/shared/design-system/colors';

export type StatusVisual = {
  label: string;
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>> | null;
  color: string;
};

export const statusVisual: Record<string, StatusVisual> = {
  Open: { label: 'Open', icon: OfficeIcon, color: colors.text.info },
  PreLaunch: { label: 'Pre-launch', icon: ClockIcon, color: colors.text.info },
  Closed: { label: 'Closed', icon: XCloseIcon, color: colors.text.error },
  Hidden: { label: 'Hidden', icon: EyeClosedIcon, color: 'rgba(255,255,255,0.6)' },
  Private: { label: 'Private', icon: null, color: 'rgba(255,255,255,0.6)' },
  None: { label: 'No Status', icon: null, color: 'rgba(255,255,255,0.6)' },
};
